import { render } from "./input-checkbox.vue?vue&type=template&id=4c68135c"
import script from "./input-checkbox.vue?vue&type=script&lang=js"
export * from "./input-checkbox.vue?vue&type=script&lang=js"

import "./input-checkbox.vue?vue&type=style&index=0&id=4c68135c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__